
<div *ngFor="let list of navbts" class="mt-2">
    <div  class="d-flex justify-content-end align-items.center px-3" *ngIf="list.btn && list.btn!=0">
        


        <div class="btn-group" >
<a [routerLink]="[btn.href]" *ngFor="let btn of list.btn"   [class]="'font-weight-bold btn btn-sm btn-success '+btn.class">{{btn.text}}</a>

</div>
        </div>
    
</div>